import type {
  InterventionMenuNavItem,
  MenuTreeItemFlatten,
} from "./intervention-menu-nav.type";
import type { InterventionSectionMenuTreeItem } from "@/modules/intervention/intervention-menu-tree";

export const getInterventionMenuNavItems = (
  menuItems: InterventionSectionMenuTreeItem[],
  selectedKey?: string
) => {
  const menuItemsFlatten = flattenMenuTreeItems(menuItems);

  if (menuItemsFlatten.length < 2) {
    return { previous: undefined, next: undefined };
  }

  return {
    previous: getPreviousMenuNavItem(menuItemsFlatten, selectedKey),
    next: getNextMenuNavItem(menuItemsFlatten, selectedKey),
  };
};

const flattenMenuTreeItems = (
  menuItems: InterventionSectionMenuTreeItem[]
): MenuTreeItemFlatten[] => {
  if (!menuItems?.length) return [];

  return menuItems
    .map(({ children, ...menuItem }) => [
      menuItem,
      ...flattenMenuTreeItems(children ?? []),
    ])
    .flat();
};

const getPreviousMenuNavItem = (
  menuItems: MenuTreeItemFlatten[],
  selectedKey?: string
) => {
  const index = getSelectedMenuItemIndex(menuItems, selectedKey);

  if (typeof index !== "number") return undefined;

  const previousItem = menuItems[index - 1] ?? menuItems[menuItems.length - 1];

  return getInterventionMenuNavItem(previousItem);
};

const getNextMenuNavItem = (
  menuItems: MenuTreeItemFlatten[],
  selectedKey?: string
) => {
  const index = getSelectedMenuItemIndex(menuItems, selectedKey);

  if (typeof index !== "number") return undefined;

  const nextItem = menuItems[index + 1] ?? menuItems[0];

  return getInterventionMenuNavItem(nextItem);
};

const getSelectedMenuItemIndex = (
  menuItems: MenuTreeItemFlatten[],
  selectedKey?: string
) => {
  if (!selectedKey) return undefined;

  const index = menuItems.findIndex((item) => item.key === selectedKey);

  if (index === -1) return undefined;

  return index;
};

const getInterventionMenuNavItem = (menuItem?: MenuTreeItemFlatten) => {
  if (!menuItem) return undefined;

  const navItem: InterventionMenuNavItem = {
    title: menuItem.title,
    data: menuItem.data,
  };

  return navItem;
};
